import { Suspense, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { devPreviews } from '@/dev-previews/registry';

export const Route = createFileRoute('/dev')({
  component: DevPlayground,
});

/**
 * Dev-only UI playground. Renders components from src/dev-previews/ with mock
 * data so new UI can be reviewed without logging in or running the backend.
 * Not available in production builds.
 */
function DevPlayground() {
  const [activeId, setActiveId] = useState(devPreviews[0]?.id ?? '');

  if (!import.meta.env.DEV) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-[hsl(var(--color-muted-foreground))]">Not available.</p>
      </div>
    );
  }

  const active = devPreviews.find((p) => p.id === activeId);

  return (
    <div className="min-h-screen bg-[hsl(var(--color-background))] text-[hsl(var(--color-foreground))]">
      <div className="border-b px-6 py-4">
        <h1 className="text-lg font-semibold">Dev UI Playground</h1>
        <p className="text-sm text-[hsl(var(--color-muted-foreground))]">
          Component previews with mock data. Dev builds only.
        </p>
      </div>
      <div className="flex">
        <aside className="w-64 shrink-0 border-r p-4">
          <nav className="space-y-1">
            {devPreviews.map((preview) => (
              <button
                key={preview.id}
                type="button"
                onClick={() => setActiveId(preview.id)}
                className={`block w-full rounded-md px-3 py-2 text-left text-sm transition-colors ${
                  preview.id === activeId
                    ? 'bg-[hsl(var(--color-accent))] font-medium'
                    : 'hover:bg-[hsl(var(--color-accent))]/50'
                }`}
              >
                <span className="block">{preview.label}</span>
                <span className="block text-xs text-[hsl(var(--color-muted-foreground))]">
                  {preview.description}
                </span>
              </button>
            ))}
          </nav>
        </aside>
        <main className="flex-1 p-6">
          {active && (
            <Suspense fallback={<p className="text-sm">Loading preview...</p>}>
              <active.Component />
            </Suspense>
          )}
        </main>
      </div>
    </div>
  );
}
